<template>
  <CustomModal
    :show="isOpen"
    :title="title"
    icon="mdi-filter"
    width="720"
    @close="isOpen = false"
  >
    <v-row v-if="campos.length > 0">
      <v-col v-for="campo in campos" :key="campo.key" :cols="campo.cols || 6" class="pb-0">
        <!-- Text Field -->
        <v-text-field
          v-if="campo.tipo === 'text'"
          :value="getFieldValue(campo.key)"
          :label="campo.label"
          :placeholder="campo.placeholder"
          :dense="campo.dense !== false"
          :outlined="campo.outlined !== false"
          :clearable="campo.clearable !== false"
          :disabled="campo.disabled"
          :hint="campo.hint"
          :persistent-hint="campo.persistentHint"
          :hide-details="campo.hideDetails !== false"
          :type="campo.inputType || 'text'"
          @input="updateField(campo.key, $event)"
        />

        <!-- Text Area -->
        <v-textarea
          v-else-if="campo.tipo === 'textarea'"
          :value="getFieldValue(campo.key)"
          :label="campo.label"
          :placeholder="campo.placeholder"
          :rows="campo.rows || 3"
          :dense="campo.dense !== false"
          :outlined="campo.outlined !== false"
          :clearable="campo.clearable !== false"
          :disabled="campo.disabled"
          :hint="campo.hint"
          :persistent-hint="campo.persistentHint"
          :hide-details="campo.hideDetails !== false"
          @input="updateField(campo.key, $event)"
        />

        <!-- Select -->
        <v-select
          v-else-if="campo.tipo === 'select'"
          :value="getFieldValue(campo.key)"
          :items="campo.items || []"
          :label="campo.label"
          :placeholder="campo.placeholder"
          :no-data-text="campo.noDataText || 'Nenhum item encontrado'"
          :dense="campo.dense !== false"
          :outlined="campo.outlined !== false"
          :clearable="campo.clearable !== false"
          :disabled="campo.disabled"
          :hint="campo.hint"
          :persistent-hint="campo.persistentHint"
          :hide-details="campo.hideDetails !== false"
          @input="updateField(campo.key, $event)"
        />
        <!-- Autocomplete -->
        <v-autocomplete
          v-else-if="campo.tipo === 'autocomplete'"
          :value="getFieldValue(campo.key)"
          :items="campo.items || []"
          :label="campo.label"
          :placeholder="campo.placeholder"
          :no-data-text="campo.noDataText || 'Nenhum item encontrado'"
          :dense="campo.dense !== false"
          :outlined="campo.outlined !== false"
          :loading="campo.loading"
          :clearable="campo.clearable !== false"
          :disabled="campo.disabled"
          :hint="campo.hint"
          :persistent-hint="campo.persistentHint"
          :hide-details="campo.hideDetails !== false"
          :hide-no-data="campo.hideNoData"
          :hide-selected="campo.hideSelected"
          :filter="campo.filter || (() => true)"
          @input="updateField(campo.key, $event)"
          @update:search-input="$emit('search-input', { key: campo.key, value: $event })"
        />
      </v-col>
    </v-row>
    <slot />

    <template #actions>
      <v-spacer />
      <v-btn text color="textPrimary" @click="isOpen = false" class="font-weight-medium">
        CANCELAR
      </v-btn>
      <v-btn color="success" dark @click="$emit('apply')" class="font-weight-medium">
        APLICAR
      </v-btn>
    </template>
  </CustomModal>
</template>

<script>
import CustomModal from "@/components/CustomModal.vue";

export default {
  name: "FiltroModal",
  components: { CustomModal },
  props: {
    value: { type: Boolean, default: false },
    title: { type: String, default: "Filtrar" },
    campos: {
      type: Array,
      default: () => [],
      // Estrutura esperada:
      // [
      //   {
      //     key: 'ano',
      //     label: 'Ano',
      //     placeholder: 'Selecione um ano',
      //     tipo: 'select', // 'select', 'text', 'textarea'
      //     items: [...],
      //     cols: 6, // tamanhao da coluna (padrao 6)
      //     dense: true, (opcional, padrao true)
      //     outlined: true, (opcional, padrao true)
      //     noDataText: 'mensagem custom' (opcional, para selects)
      //   }
      // ]
    },
    filtros: {
      type: Object,
      default: () => ({}),
    },
  },
  computed: {
    isOpen: {
      get() {
        return this.value;
      },
      set(newValue) {
        this.$emit("input", newValue);
      },
    },
  },
  methods: {
    getFieldValue(key) {
      return this.filtros[key];
    },
    updateField(key, value) {
      this.$emit("update:filtros", {
        ...this.filtros,
        [key]: value,
      });
    },
  },
};
</script>

<style scoped>
.headline {
  font-weight: 700;
}
</style>
